import { Injectable } from '@angular/core';
import { Currency } from '../../../utils/currency';
import { Choice } from '../../../models/choice';
import { Store } from '@ngrx/store';
import { selectProfileCurrencies, selectProfileCurrency } from '../../../store/profile/profile.state';
import { AppState } from '../../../store';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {

    constructor(private store: Store<AppState>) {}

    conversions = this.store.selectSignal(selectProfileCurrencies);

    prefix(currency: string): string {
        return Currency.prefix(currency);
    }

    suffix(currency: string): string {
        return Currency.suffix(currency);
    }

    normalize(currency: string, amount: number | string): string {
        return Currency.normalize(currency, amount);
    }

    render(amount: number, currency: string): string {
        return Currency.render(amount, currency);
    }

    convert(amount: number, source: string, target: string): number {
        const sourceConversion = this.conversions().find(c => c.currency === source);
        const targetConversion = this.conversions().find(c => c.currency === target);
        if (sourceConversion && targetConversion) {
            const profileCurrencyAmount = amount * sourceConversion.conversion;
            return profileCurrencyAmount / targetConversion.conversion;
        }
        return amount;
    }

    from(amount: number, currency: string): number {
        const conversions = this.conversions();
        const sourceConversion = conversions.find(c => c.currency === currency);
        if (sourceConversion) {
            return sourceConversion.conversion * amount;
        }
        return amount;
    }

    choices(): Choice[] {
        return this.conversions().map(c => ({ label: c.currency, value: c.currency }));
    }
}
